import { useQuery } from '@tanstack/react-query';
import { getTransferableProducts } from '../../../../api/transfer';

// 회원이 보유한 양도 가능 수강권/이용권 목록을 조회한다.
// queryKey 에 memberId·branchId 를 모두 포함해 회원/지점이 바뀌면 캐시가 분리되도록 한다.
// 보유 상품은 자주 바뀌지 않으므로 staleTime 을 3분으로 늘려 탭 전환 시 불필요한 재조회를 줄인다.
export const TRANSFERABLE_PRODUCTS_KEY = 'transferableProducts';

const useTransferableProducts = ({ memberId, branchId, token }) =>
  useQuery({
    queryKey: [TRANSFERABLE_PRODUCTS_KEY, memberId, branchId],
    queryFn: () => getTransferableProducts(memberId, branchId, token),
    enabled: !!memberId && !!branchId && !!token,
    staleTime: 1000 * 60 * 3,
  });

export default useTransferableProducts;
